import { Box, Paper, TableCell, TableRow, Typography } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

/**
 * Superfícies compartilhadas do sistema: borda sutil no lugar de sombra pesada,
 * cabeçalho compacto e tabelas de baixa densidade visual.
 */

export const Cartao = styled(Paper)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    borderRadius: 14,
    border: `1px solid ${theme.palette.divider}`,
    backgroundImage: "none",
    boxShadow: "none",
    overflow: "hidden",
}));

export const CabecalhoCartao = styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    padding: theme.spacing(1.75, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
}));

export const TituloCartao = styled(Typography)({
    fontSize: "0.8125rem",
    fontWeight: 600,
    letterSpacing: "0.01em",
});

export const Rotulo = styled(Typography)(({ theme }) => ({
    fontSize: "0.6875rem",
    fontWeight: 700,
    letterSpacing: "0.07em",
    textTransform: "uppercase",
    color: theme.palette.text.secondary,
}));

/** Pílula de status com bolinha — usada para estados aberto/fechado. */
export const PilulaStatus = styled(Box, {
    shouldForwardProp: prop => prop !== "cor",
})<{ cor: string }>(({ cor }) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: 7,
    height: 26,
    padding: "0 10px",
    borderRadius: 999,
    fontSize: "0.75rem",
    fontWeight: 600,
    whiteSpace: "nowrap",
    color: cor,
    backgroundColor: alpha(cor, 0.12),
    "&::before": {
        content: '""',
        width: 7,
        height: 7,
        borderRadius: "50%",
        backgroundColor: "currentColor",
    },
}));

export const CorpoRolavel = styled(Box)(({ theme }) => ({
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    "&::-webkit-scrollbar": { width: 6 },
    "&::-webkit-scrollbar-track": { background: "transparent" },
    "&::-webkit-scrollbar-thumb": {
        borderRadius: 8,
        backgroundColor: alpha(theme.palette.text.secondary, 0.22),
    },
    "&:hover::-webkit-scrollbar-thumb": {
        backgroundColor: alpha(theme.palette.text.secondary, 0.38),
    },
}));

export const CelulaCabecalho = styled(TableCell)(({ theme }) => ({
    fontSize: "0.6875rem",
    fontWeight: 700,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 2),
    whiteSpace: "nowrap",
}));

export const CelulaCorpo = styled(TableCell)(({ theme }) => ({
    fontSize: "0.8125rem",
    color: theme.palette.text.primary,
    borderBottom: `1px solid ${alpha(theme.palette.divider, 0.6)}`,
    padding: theme.spacing(1.25, 2),
}));

export const LinhaTabela = styled(TableRow)(({ theme }) => ({
    transition: theme.transitions.create("background-color", { duration: 150 }),
    "&:hover": { backgroundColor: alpha(theme.palette.text.primary, 0.03) },
    "&:last-of-type td": { borderBottom: "none" },
}));

export const EstadoVazio = styled(Box)(({ theme }) => ({
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(4, 2),
    color: theme.palette.text.secondary,
    textAlign: "center",
    "& svg": { fontSize: 30, opacity: 0.35 },
}));
